import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__kNUM0","title4":"styles_title4__JEtLa","body1":"styles_body1__LDinR","body2":"styles_body2__1Y38g","caption1":"styles_caption1__LvaW+","caption2":"styles_caption2__pufS8","nav":"styles_nav__mILmr","navIcon":"styles_navIcon__qIajA","title3":"styles_title3__5PBqb"};
export const b = b_.with('icon');